module.exports = __webpack_public_path__ + "img/logo_viva1.a0c23e1d.png";